import { DailyGiftModal } from "./features/daily-gift/DailyGiftModal.jsx";
import { getAuthData } from "./features/auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { Ii } from "./assets.jsx";
import { Xo } from "./assets.jsx";
import { jn } from "./assets.jsx";
import { Zo } from "./assets.jsx";
import { Mo } from "./assets.jsx";
import { $o } from "./assets.jsx";
import { Ns } from "./assets.jsx";
import { Jo } from "./assets.jsx";
import { Vo } from "./assets.jsx";
import { Yo } from "./assets.jsx";
import { Qo } from "./assets.jsx";
import { Ko } from "./assets.jsx";
import { useStartup } from "./features/startup/useStartup.jsx";
import { useMiniAppNavigation } from "./hooks/useMiniAppNavigation.jsx";
import { initialNavigation } from "./features/navigation/launch.js";
import * as React from "react";
import { openCards } from "./api/cardOpening.jsx";
import { changeCardUniverse } from "./api/cardOpening.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { CasesPage } from "./features/cases/CasesPage.jsx";
import { RatingPage } from "./pages/RatingPage.jsx";
import { SummerEventPage } from "./pages/SummerEventPage.jsx";
import { FishingArcade } from "./FishingArcade.jsx";
import { MetaPassPage } from "./pages/MetaPassPage.jsx";
import { VaBankPage } from "./pages/VaBankPage.jsx";
import { MiniGamesPage } from "./pages/MiniGamesPage.jsx";
import { HalloweenLobby } from "./features/seasonal-games/HalloweenLobby.jsx";
import { HalloweenEventPage } from "./features/seasonal-games/HalloweenEventPage.jsx";
import { PenaltyPage } from "./features/penalty/PenaltyPage.jsx";
import { HomePage } from "./pages/HomePage.jsx";
import { ShopPage } from "./pages/ShopPage.jsx";
import { openTbankPayment, watchTbankPayment } from "./features/shop/tbank.js";
import { ArenaPage } from "./pages/ArenaPage.jsx";
import { CollectionPage } from "./pages/CollectionPage.jsx";
import { WalletPage } from "./pages/WalletPage.jsx";
import { ProfilePage } from "./pages/ProfilePage.jsx";
import { navigationStyles } from "./components/AppNavigation.jsx";
import { AppNavigation } from "./components/AppNavigation.jsx";
import { KingOfTheHillPage } from "./pages/KingOfTheHillPage.jsx";
import { HalloweenAccents } from "./components/HalloweenAccents.jsx";
import { StartupScreen } from "./features/startup/StartupScreen.jsx";
export const Dm = {
  light: 0,
  default: 0,
  hard: 0,
  halloween: 0
};
export const nS = {
  id: 0,
  firstName: "Meta",
  lastName: "Player",
  username: "metacard_player"
};
export const Fm = "metacard-active-tab";
export const sS = [{
  id: 1,
  icon: "💎",
  caseImage: Ii,
  rewardImage: Xo
}, {
  id: 2,
  icon: "🎴",
  caseImage: jn,
  rewardImage: Zo
}, {
  id: 3,
  icon: "🐚",
  caseImage: Mo,
  rewardImage: $o
}, {
  id: 4,
  icon: "✨",
  caseImage: Ns,
  rewardImage: Jo
}, {
  id: 5,
  icon: "🏆",
  caseImage: jn,
  rewardImage: Vo
}, {
  id: 6,
  icon: "💎",
  caseImage: Ii,
  rewardImage: Yo
}, {
  id: 7,
  icon: "🎴",
  caseImage: Mo,
  rewardImage: Qo
}, {
  id: 8,
  icon: "🐚",
  caseImage: Ns,
  rewardImage: Ko
}];
export function initialTab() {
  return initialNavigation().tab;
}
export function App() {
  const u = useStartup(),
    {
      tab: o,
      walletOpen: m,
      casesOpen: r,
      homeView: g,
      setWalletOpen: j,
      setCasesOpen: B,
      setHomeView: U,
      openTab: N
    } = useMiniAppNavigation(initialNavigation()),
    [y, X] = React.useState(nS),
    [M, R] = React.useState({
      friends: 0,
      privilege: "Стандарт"
    }),
    [H, Y] = React.useState(0),
    [P, W] = React.useState({
      crystals: 0,
      spins: 0,
      gems: 0,
      eventCurrency: 0,
      eventCurrencyIcon: "✦",
      eventCurrencyName: "Ивент"
    }),
    [ee, ie] = React.useState(Dm),
    [w, I] = React.useState(""),
    [ne, oe] = React.useState(sS);
  React.useLayoutEffect(() => {
    const C = window.history.scrollRestoration;
    return window.history.scrollRestoration = "manual", window.scrollTo(0, 0), () => {
      window.history.scrollRestoration = C;
    };
  }, []), React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [o, m, r, g]);
  const T = C => {
    oe(f => [{
      ...C,
      id: Date.now() + Math.random()
    }, ...f].slice(0, 8));
  };
  React.useEffect(() => {
    const C = getAuthData();
    if (!C) return;
    (async () => {
      try {
        const h = await fetch("/api/me", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            initData: C
          })
        });
        if (!h.ok) throw new Error("profile_request_failed");
        const p = await h.json();
        X(p.user), Y(Number(p.balance.metacoins ?? 0)), W({
          ...p.balance,
          gems: Number(p.balance.gems ?? 0)
        }), ie(p.balance.cases || Dm), R(p.profile), fetch("/api/rating/avatar/sync", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            initData: C
          })
        }).then(G => {
          G.ok && window.dispatchEvent(new Event("rating-avatar-synced"));
        }).catch(() => {});
      } catch {
        I("Не удалось загрузить данные MetaCard");
      }
    })();
  }, []);
  React.useEffect(() => watchTbankPayment(result => {
    Y(Number(result.balance));
    V(`Зачислено ${Number(result.credited_coins).toLocaleString("ru-RU")} MetaCoin`);
    window.dispatchEvent(new Event("metacard-payment-credited"));
  }, message => V(message)), []);
  const D = async (C, f = !1, method = "stars", email = "") => {
      if (method === "tbank") {
        await openTbankPayment(C, f, email);
        V("Завершите оплату на странице Т‑Банка. Баланс обновится автоматически.");
        return;
      }
      const h = getAuthData(),
        p = window.Telegram?.WebApp?.openInvoice;
      if (!h || !p) {
        V("Покупка доступна только внутри Telegram");
        return;
      }
      try {
        const G = await fetch("/api/payments/metacoin-stars", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            initData: h,
            coins: C,
            custom: f
          })
        });
        if (!G.ok) throw new Error("invoice_request_failed");
        const {
          invoiceLink: F,
          paymentId: ce
        } = await G.json();
        await new Promise(ue => {
          p(F, Me => {
            if (Me !== "paid") {
              Me === "cancelled" && V("Оплата отменена"), Me === "failed" && V("Не удалось провести оплату"), ue();
              return;
            }
            (async () => {
              try {
                for (let Re = 0; Re < 12; Re++) {
                  const wt = new AbortController(),
                    me = window.setTimeout(() => wt.abort(), 5e3);
                  try {
                    const K = await fetch("/api/payments/metacoin-status", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify({
                        initData: h,
                        paymentId: ce
                      }),
                      signal: wt.signal
                    });
                    if (!K.ok) throw new Error("payment_status_failed");
                    const re = await K.json();
                    if (re.paid && re.balance !== void 0 && re.credited_coins !== void 0) {
                      Y(re.balance), V(`Зачислено ${re.credited_coins.toLocaleString("ru-RU")} MetaCoin`);
                      return;
                    }
                  } finally {
                    window.clearTimeout(me);
                  }
                  await new Promise(K => window.setTimeout(K, 750));
                }
                V("Оплата принята. Начисление обрабатывается — обновите баланс чуть позже.");
              } catch {
                V("Оплата принята. Проверим баланс при следующем открытии приложения.");
              } finally {
                ue();
              }
            })();
          });
        });
      } catch {
        V("Не удалось создать счёт на оплату");
      }
    },
    le = async (C, f) => {
      const h = getAuthData();
      if (!h) return V("Покупка доступна только внутри Telegram"), !1;
      try {
        const p = await fetch("/api/shop/cases/purchase", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: h,
              caseId: C,
              amount: f
            })
          }),
          G = await p.json();
        if (!p.ok) throw new Error(G.error || "Не удалось купить кейсы");
        return Y(Number(G.metacoins || 0)), G.cases && ie(G.cases), V(`Куплено кейсов: ×${f}`), !0;
      } catch (p) {
        return V(p instanceof Error ? p.message : "Не удалось купить кейсы"), !1;
      }
    },
    te = async C => {
      const f = getAuthData();
      if (!f) return V("Покупка доступна только внутри Telegram"), !1;
      try {
        const h = await fetch("/api/shop/promotions/purchase", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: f,
              promotionId: C
            })
          }),
          p = await h.json();
        if (!h.ok) throw new Error(p.error || "Не удалось купить акцию");
        return Y(Number(p.metacoins || 0)), p.cases && ie(p.cases), V(`Куплено кейсов: ×${p.amount || 0}`), !0;
      } catch (h) {
        return V(h instanceof Error ? h.message : "Не удалось купить акцию"), !1;
      }
    },
    Z = async (C, f) => {
      const h = getAuthData();
      if (!h) return V("Покупка доступна только внутри Telegram"), !1;
      try {
        const p = await fetch("/api/shop/resources/purchase", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: h,
              resource: C,
              amount: f
            })
          }),
          G = await p.json();
        if (!p.ok) throw new Error(G.error || "Не удалось выполнить покупку");
        return Y(Number(G.metacoins || 0)), G.resources && W(F => ({
          ...F,
          crystals: G.resources.crystals,
          spins: G.resources.spins
        })), V(`Получено: ${f.toLocaleString("ru-RU")} ${C === "spins" ? "круток" : "кристаллов"}`), !0;
      } catch (p) {
        return V(p instanceof Error ? p.message : "Не удалось выполнить покупку"), !1;
      }
    };
  React.useEffect(() => {
    sessionStorage.setItem(Fm, o);
  }, [o]);
  const V = C => {
      I(C), window.setTimeout(() => I(""), 2200);
    },
    ae = React.useRef(null);
  React.useEffect(() => () => ae.current?.abort(), []);
  const Te = async (C, f) => {
      const h = getAuthData();
      if (!h) throw new Error("Открытие карт доступно внутри Telegram");
      ae.current?.abort();
      const p = await openCards(h, C, f);
      R(profile => ({ ...profile, freeCardAvailableAt: p.freeCardAvailableAt,
        freeSpins: p.freeSpins, freeSpinsCapacity: p.freeSpinsCapacity,
        freeSpinNextAt: p.freeSpinNextAt, freeSpinInterval: p.freeSpinInterval }));
      if (W(G => ({
        ...G,
        spins: p.balance.spins,
        gems: p.balance.gems
      })), p.status !== "processing") {
        const G = new AbortController();
        ae.current = G, (async () => {
          try {
            const F = await fetch("/api/me", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                initData: h
              }),
              signal: G.signal
            });
            if (F.ok) {
              const ce = await F.json();
              G.signal.aborted || R(ce.profile);
            }
          } catch {}
        })();
      }
      return p;
    },
    je = async C => {
      ae.current?.abort();
      const f = getAuthData();
      if (!f) throw new Error("Выбор вселенной доступен внутри Telegram");
      const h = await changeCardUniverse(f, C);
      R(p => ({
        ...p,
        universe: h.universeName,
        collectionOwned: h.owned,
        collectionTotal: h.total
      }));
    },
    k = async C => {
      const f = getAuthData();
      if (!f) return V("Покупка доступна только внутри Telegram"), !1;
      try {
        const h = await fetch("/api/metapass/purchase", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: f,
              passType: C
            })
          }),
          p = await h.json();
        if (!h.ok) throw new Error(p.error || "Не удалось купить MetaPass");
        return Y(Number(p.metacoins || 0)), p.metapass && R(G => G.metapass ? {
          ...G,
          metapass: {
            ...G.metapass,
            season: p.metapass.season,
            type: p.metapass.type
          }
        } : G), V(`${C === "paid" ? "Платный" : "Платный+"} MetaPass активирован`), !0;
      } catch (h) {
        return V(h instanceof Error ? h.message : "Не удалось купить MetaPass"), !1;
      }
    },
    O = async (C, f) => {
      const h = getAuthData();
      if (!h) return V("Получение наград доступно только внутри Telegram"), !1;
      try {
        const p = await fetch("/api/metapass/claim", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              initData: h,
              track: C,
              level: f
            })
          }),
          G = await p.text();
        let F;
        try {
          F = JSON.parse(G);
        } catch {
          throw new Error(p.ok ? "Некорректный ответ сервера" : `Ошибка сервера (${p.status})`);
        }
        if (!p.ok) throw new Error(F.error || "Не удалось забрать награду");
        return F.resources && W(ce => ({
          ...ce,
          crystals: F.resources.crystals,
          spins: F.resources.spins
        })), F.metapass && R(ce => ce.metapass ? {
          ...ce,
          metapass: {
            ...ce.metapass,
            freePick: F.metapass.freePick,
            paidPick: F.metapass.paidPick,
            paidPlusPick: F.metapass.paidPlusPick
          }
        } : ce), V("Награда получена"), !0;
      } catch (p) {
        return V(p instanceof Error ? p.message : "Не удалось забрать награду"), !1;
      }
    },
    L = async C => {
      try {
        await navigator.clipboard.writeText(C);
      } catch {
        const f = document.createElement("textarea");
        f.value = C, f.style.position = "fixed", f.style.opacity = "0", document.body.appendChild(f), f.select(), document.execCommand("copy"), f.remove();
      }
      V("Реферальная ссылка скопирована");
    },
    se = C => {
      const f = encodeURIComponent("Присоединяйся к MetaCard по моей ссылке!"),
        h = `https://t.me/share/url?url=${encodeURIComponent(C)}&text=${f}`;
      window.open(h, "_blank", "noopener,noreferrer");
    };
  return u.ready ? jsxRuntime.jsxs("main", {
    className: `app-shell${o === "king-of-the-hill" ? " king-hill-shell" : ""}${o === "home" && !r && g === "main" ? " home-shell" : ""}${o === "home" && !r && g === "vabank" ? " vabank-shell" : ""}${o === "home" && !r && g === "penalty" ? " penalty-shell" : ""}${o === "home" && !r && g === "halloween" ? " flight-shell" : ""}${o === "home" && !r && g === "halloween-event" ? " event-shell" : ""}`,
    children: [jsxRuntime.jsx(DailyGiftModal, { onReward: async () => {
      try {
        const response = await fetch("/api/me", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ initData: getAuthData() }) });
        if (response.ok) { const data = await response.json(); W({ ...data.balance, gems: Number(data.balance.gems ?? 0) }); ie(data.balance.cases || Dm); Y(Number(data.balance.metacoins ?? 0)); }
      } catch { /* The next profile refresh will recover the balances. */ }
    } }), !(o === "home" && !r && g === "main") && jsxRuntime.jsx(HalloweenAccents, {
      section: o === "home" ? (r ? "cases" : g) : (o === "profile" && m ? "wallet" : o)
    }), jsxRuntime.jsxs("section", {
      className: o === "profile" ? "content profile-content" : o === "home" && !r ? "content home-content" : o === "shop" ? "content shop-content" : o === "collection" ? "content collection-content" : "content",
      children: [o === "home" && (r ? jsxRuntime.jsx(CasesPage, {
        onBack: () => B(!1),
        onSelect: V,
        recentDrops: ne,
        onDrop: T,
        caseBalances: ee,
        onCaseBalancesChange: ie,
        onResourcesChange: C => W(f => ({
          ...f,
          ...C
        })),
        onMetaCoinsChange: Y
      }) : g === "rating" ? jsxRuntime.jsx(RatingPage, {
        player: y,
        onBack: () => U("main")
      }) : g === "summer" ? jsxRuntime.jsx(SummerEventPage, {
        resources: P,
        onBack: () => U("main"),
        onOpenFishing: () => U("fishing")
      }) : g === "fishing" ? jsxRuntime.jsx(FishingArcade, {
        onBack: () => U("summer"),
        onShellsRewarded: C => W(f => ({
          ...f,
          eventCurrency: f.eventCurrency + C
        }))
      }) : g === "metapass" ? jsxRuntime.jsx(MetaPassPage, {
        metapass: M.metapass,
        onBack: () => U("main"),
        onPurchase: k,
        onClaim: O
      }) : g === "minigames" ? jsxRuntime.jsx(MiniGamesPage, {
        onBack: () => U("main"),
        onOpenPenalty: () => U("penalty"),
        onOpenVaBank: () => U("vabank")
      }) : g === "halloween-event" ? jsxRuntime.jsx(HalloweenEventPage, {
        onBack: () => U("main"),
        onOpenFlight: () => U("halloween"),
        onRewardsChanged: async () => {
          const response = await fetch("/api/me", {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ initData: getAuthData() }), signal: AbortSignal.timeout(12000)
          });
          if (!response.ok) throw new Error("balance_refresh_failed");
          const player = await response.json();
          Y(Number(player.balance.metacoins ?? 0));
          W({ ...player.balance, gems: Number(player.balance.gems ?? 0) });
          ie(player.balance.cases || Dm);
          R(player.profile);
        }
      }) : g === "halloween" ? jsxRuntime.jsx(HalloweenLobby, {
        onBack: () => U("halloween-event")
      }) : g === "penalty" ? jsxRuntime.jsx(PenaltyPage, {
        onBack: () => U("minigames"),
        onBalanceChange: balance => {
          Y(balance.metacoins);
          W(previous => ({ ...previous, crystals: balance.crystals, spins: balance.spins, gems: balance.gems }));
        }
      }) : g === "vabank" ? jsxRuntime.jsx(VaBankPage, {
        onBack: () => U("minigames"),
        onBalanceChange: ({
          metacoins: C,
          crystals: f,
          spins: h,
          gems: p
        }) => {
          Y(C), W(G => ({
            ...G,
            crystals: f,
            spins: h,
            gems: p
          }));
        }
      }) : jsxRuntime.jsx(HomePage, {
        metacoins: H,
        resources: P,
        meta: M,
        onOpenCards: Te,
        onChangeUniverse: je,
        onOpenCases: () => B(!0),
        onOpenRating: () => U("rating"),
        onOpenMetaPass: () => U("metapass"),
        onOpenMiniGames: () => U("minigames"),
        onOpenHalloween: () => U("halloween-event"),
        onNotice: V,
        startupData: u.data
      })), o === "shop" && jsxRuntime.jsx(ShopPage, {
        balance: H,
        resources: P,
        onBuyMetaCoins: D,
        onBuyCase: le,
        onBuyPromotion: te,
        onBuyResource: Z
      }), o === "arena" && jsxRuntime.jsx(ArenaPage, {
        onNotice: V
      }), o === "king-of-the-hill" && jsxRuntime.jsx(KingOfTheHillPage, {
      }), o === "collection" && jsxRuntime.jsx(CollectionPage, {
        meta: M
      }), o === "profile" && (m ? jsxRuntime.jsx(WalletPage, {
        onBack: () => j(!1),
        onBuy: D
      }) : jsxRuntime.jsx(ProfilePage, {
        player: y,
        meta: M,
        onOpenCollection: () => N("collection"),
        onCopyReferral: L,
        onShareReferral: se,
        onNotice: V,
        onPromoRedeemed: ({
          crystals: C,
          spins: f,
          metacoins: h
        }) => {
          W(p => ({
            ...p,
            crystals: p.crystals + C,
            spins: p.spins + f
          })), Y(p => p + h);
        }
      }))]
    }), jsxRuntime.jsx("nav", {
      className: navigationStyles.navigation,
      "aria-label": "Основная навигация",
      children: jsxRuntime.jsx(AppNavigation, {
        activeTab: o,
        onSelect: N
      })
    }), w && jsxRuntime.jsx("div", {
      className: "toast",
      children: w
    })]
  }) : jsxRuntime.jsx(StartupScreen, {
    phase: u.phase
  });
}
export default App;
